const map = {
	"./client_1.avif": 8165,
	"./client_10.avif": 7207,
	"./client_11.avif": 7352,
	"./client_12.avif": 5709,
	"./client_13.avif": 254,
	"./client_14.avif": 2803,
	"./client_15.avif": 6260,
	"./client_16.avif": 5193,
	"./client_17.avif": 8778,
	"./client_18.avif": 8943,
	"./client_19.avif": 4432,
	"./client_2.avif": 3536,
	"./client_20.avif": 8396,
	"./client_21.avif": 4075,
	"./client_3.avif": 9007,
	"./client_4.avif": 8546,
	"./client_5.avif": 4001,
	"./client_6.avif": 5516,
	"./client_7.avif": 1195,
	"./client_8.avif": 7790,
	"./client_9.avif": 9069
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5036;